import { MdDashboard } from "react-icons/md";
import { FaBookMedical } from "react-icons/fa";
import { SiCashapp } from "react-icons/si";
import { CiSettings } from "react-icons/ci";
import { MdConstruction } from "react-icons/md";
import { FaDashcube } from "react-icons/fa6";
import { FaAddressBook } from "react-icons/fa";

export const data = [
    {name:'டாஷ்போர்டு',icon:< FaDashcube  fontSize={22}/>, path:'/'},
    {name:'முன்பதிவு',icon:< FaAddressBook  fontSize={22}/>, path:'booking'},
    {name:'பரிவர்த்தனை',icon:<SiCashapp fontSize={22}/>, path:'transaction'},
    {name:'கட்டமைப்பு',icon:<CiSettings fontSize={22}/>, path:'config'},
   
]